export type FileType = 'pdf' | 'word' | 'excel' | 'powerpoint' | 'other';

export type FileTypeInfo = {
  type: FileType;
  label: string;
};

const TYPE_BY_EXTENSION: Record<string, FileType> = {
  pdf: 'pdf',
  doc: 'word',
  docx: 'word',
  xls: 'excel',
  xlsx: 'excel',
  csv: 'excel',
  ppt: 'powerpoint',
  pptx: 'powerpoint',
};

/** Langer dan dit tonen we niet als label — dat zou de badge oprekken. */
const MAX_LABEL_LENGTH = 4;

const fallback = (): FileTypeInfo => ({ type: 'other', label: 'ONBEKEND' });

/**
 * Bepaalt de icoon- en tintfamilie plus het weergavelabel op basis van de
 * originele bestandsnaam. Puur voor weergave in de documentlijst: het label
 * zegt wat het bestand ís, niet wat de viewer ermee kan. De viewer-routing
 * loopt via resolveDocumentKind in documentKind.ts en staat hier los van.
 */
export function resolveFileType(
  sourceFileName: string | null | undefined,
): FileTypeInfo {
  if (!sourceFileName) return fallback();

  const dot = sourceFileName.lastIndexOf('.');
  if (dot === -1 || dot === sourceFileName.length - 1) return fallback();

  const extension = sourceFileName.slice(dot + 1).toLowerCase();

  const known = TYPE_BY_EXTENSION[extension];
  if (known) return { type: known, label: extension.toUpperCase() };

  if (extension.length > MAX_LABEL_LENGTH) return fallback();
  return { type: 'other', label: extension.toUpperCase() };
}
